import { ApplicationCitizenshipStatusScreen } from "@/interactors/ApplicationCitizenshipStatusScreen";

export default function CitizenshipStatus() {
  return <ApplicationCitizenshipStatusScreen />;
}
